import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getAccommodationQueryOptions,
  getAccommodationWithFulfillmentsQueryOptions,
} from "../accommodations";
import {
  getAllReservationServicesQueryOptions,
  getAllReservationServicesWithFulfillmentsQueryOptions,
  getReservationServicesQueryOptions,
} from "../reservation-services";
import { useToast } from "../use-toast";
import {
  getReservationQueryOptions,
  getReservationsQueryOptions,
} from "./get.hooks";
import { getReservationDaysQueryOptions } from "../reservation-days";

export function useDeleteReservation(opts?: {
  onSuccess?: () => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/reservations/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(getReservationsQueryOptions.queryKey, (old) =>
        old?.filter((r) => r.id !== id),
      );
      queryClient.setQueryData(
        getAllReservationServicesQueryOptions.queryKey,
        (old) => old?.filter((rs) => rs.reservationId !== Number.parseInt(id)),
      );
      queryClient.resetQueries({
        queryKey: getReservationQueryOptions(id).queryKey,
      });
      queryClient.resetQueries({
        queryKey: getAccommodationQueryOptions(id).queryKey,
      });
      queryClient.resetQueries({
        queryKey: getAccommodationWithFulfillmentsQueryOptions(id).queryKey,
      });
      queryClient.resetQueries({
        queryKey: getReservationServicesQueryOptions(id).queryKey,
      });
      queryClient.resetQueries({
        queryKey:
          getAllReservationServicesWithFulfillmentsQueryOptions(id).queryKey,
      });
      queryClient.resetQueries({
        queryKey: getReservationDaysQueryOptions(id).queryKey,
      });
      toast({
        title: "toast.reservationDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deleteReservationError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
